module.exports = __webpack_public_path__ + "img/CM-EC-26-Mitsubishi-Lifestyle.7c834597.jpg";